const ColumnGroup = ({ columns }) => (
  <colgroup>
    {columns.map((column, i) => (
      <col span="1" key={i} style={{ width: column.width }}></col>
    ))}
  </colgroup>
);

export default ColumnGroup;
